export default "__VITE_ASSET__5lqHIT4A__"